module.exports = __webpack_public_path__ + "assets/img/download-btn-83b94a9d.png";